var map = {
	"./de-DE": "5063",
	"./de-DE.json": "5063",
	"./en-GB": "b952",
	"./en-GB.json": "b952",
	"./fr-FR": "6ed2",
	"./fr-FR.json": "6ed2",
	"./nl-NL": "8dd1",
	"./nl-NL.json": "8dd1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef61";